"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.number.to-fixed.js");
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _paulCorePackage = require("paul-core-package");
var _DataGridProTable = _interopRequireDefault(require("../DataGridProTable"));
var _HistoryModule = _interopRequireDefault(require("../../styles/components/Flushing/History.module.css"));
var _hooks = require("../../hooks");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const emptyStyle = {
  color: "var(--main-color-cl-21)",
  fontWeight: 'normal',
  fontSize: '14px'
};
const dashes = '--';
const getDate = date => "".concat(_paulCorePackage.functions.getDateFormat(date, 'DD.MM.YY'), "\n").concat(_paulCorePackage.functions.getDateFormat(date, 'H:mm'), " Uhr"); // 'hh:mm' when localization
const getDateForSorting = date => "".concat(_paulCorePackage.functions.getDateFormat(date, 'DD.MM.YY'), " ").concat(_paulCorePackage.functions.getDateFormat(date, 'H:mm'), " Uhr"); // 'hh:mm' when localization

const RenderDateCell = _ref => {
  let {
    date = null,
    format = 'DD.MM.YY'
  } = _ref;
  return (0, _react.useMemo)(() =>
  /*#__PURE__*/
  // <div className={styles.date_cell_td}>
  _react.default.createElement("div", {
    className: ""
  }, date ? _paulCorePackage.functions.getDateFormat(date, format) : '--'), [date]);
};
const RenderDurationCell = _ref2 => {
  let {
    duration = null
  } = _ref2;
  return (0, _react.useMemo)(() => {
    const min = duration ? (duration / 60).toFixed(0) : 0;
    const sec = duration ? duration - min * 60 : 0;
    return (
      /*#__PURE__*/
      // <div className={styles.date_cell_td}>
      _react.default.createElement("div", {
        className: ""
      }, duration ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, min && "".concat(min, " min "), "".concat(sec, " sec")) : 'cancelled')
    );
  }, [duration]);
};
const RenderTemplateCellValue = _ref3 => {
  let {
    device = {},
    regularByDisplayNameId,
    isBold = false,
    isTmpEnd
  } = _ref3;
  const {
    thingPDIDDevice,
    equipmentType,
    unit,
    tmpStart,
    tmpEnd
  } = device;
  // const valueObj = useGetValueByRegDeviceId({ thingPDIDDevice, regular: regularByDisplayNameId})
  // const { value, unit, valueType } = valueObj || {};
  // const {isDisabled} = useMemo(() => getDeviceInfo({equipmentType, thingPDIDDevice}), [device]);
  const tUnit = (0, _hooks.useGetUntTranslate)({
    unit
  });
  const value = isTmpEnd ? tmpEnd : tmpStart;
  return (0, _react.useMemo)(() => /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_HistoryModule.default.nowrap_cell, " ").concat(isBold ? 'fw-bold' : ''),
    style: value ? null : emptyStyle
  }, "".concat(value ? "".concat((+value).toFixed(2), " ").concat(tUnit) : dashes))
  // ), [value, tUnit, valueType]);
  , [tUnit, value]);
};
const History = () => {
  const columns = (0, _react.useMemo)(() => [{
    field: 'date',
    headerName: 'Date',
    flex: 6,
    cellClassName: 'dateCell',
    valueGetter: d => {
      var _d$row, _d$row2;
      return (_d$row = d.row) !== null && _d$row !== void 0 && _d$row.date ? _paulCorePackage.functions.getDateFormat((_d$row2 = d.row) === null || _d$row2 === void 0 ? void 0 : _d$row2.date, 'DD. MMMM YYYY') : '';
    },
    renderCell: d => {
      var _d$row3;
      return /*#__PURE__*/_react.default.createElement(RenderDateCell, {
        date: (_d$row3 = d.row) === null || _d$row3 === void 0 ? void 0 : _d$row3.date,
        format: "DD. MMMM YYYY"
      });
    }
  }, {
    field: 'time',
    headerName: 'Time',
    flex: 4,
    cellClassName: 'dateCell',
    valueGetter: d => {
      var _d$row4, _d$row5;
      return (_d$row4 = d.row) !== null && _d$row4 !== void 0 && _d$row4.date ? getDateForSorting((_d$row5 = d.row) === null || _d$row5 === void 0 ? void 0 : _d$row5.date) : '';
    },
    renderCell: d => {
      var _d$row6;
      return /*#__PURE__*/_react.default.createElement(RenderDateCell, {
        date: (_d$row6 = d.row) === null || _d$row6 === void 0 ? void 0 : _d$row6.date,
        format: "hh:mm a"
      });
    }
  }, {
    field: 'duration',
    headerName: 'Duration',
    flex: 6,
    renderCell: d => {
      var _d$row7;
      return /*#__PURE__*/_react.default.createElement(RenderDurationCell, {
        duration: (_d$row7 = d.row) === null || _d$row7 === void 0 ? void 0 : _d$row7.duration
      });
    },
    cellClassName: 'dateCell',
    sortable: false
  }, {
    field: 'tmpStart',
    headerName: 'Tmp Start',
    renderCell: d => /*#__PURE__*/_react.default.createElement(RenderTemplateCellValue, {
      device: d.row,
      regularByDisplayNameId: _paulCorePackage.constants.regularsByDisplayNameId.temperatureRegex
    }),
    flex: 4,
    cellClassName: 'dateCell'
  }, {
    field: 'tmpEnd',
    headerName: 'Tmp End',
    flex: 4,
    renderCell: d => /*#__PURE__*/_react.default.createElement(RenderTemplateCellValue, {
      device: d.row,
      regularByDisplayNameId: _paulCorePackage.constants.regularsByDisplayNameId.temperatureRegex,
      isTmpEnd: true
    }),
    cellClassName: 'dateCell'
  }, {
    field: 'user',
    headerName: 'User',
    flex: 10,
    cellClassName: 'dateCell'
  }], []);
  const rows = (0, _react.useMemo)(() => [
    // {
    //     id: 1,
    //     date: new Date(),
    //     duration: 300,
    //     tmpStart: 20,
    //     tmpEnd: 40,
    //     unit: 130,
    //     user: 'Vasaaa',
    // },
    // {
    //     id: 2,
    //     date: 1680788519018,
    //     duration: 10,
    //     tmpStart: 35,
    //     tmpEnd: 48,
    //     unit: 130,
    //     user: 'Dima',
    // },
    // {
    //     id: 3,
    //     date: 1681208909386,
    //     duration: 0,
    //     tmpStart: 35,
    //     tmpEnd: 48,
    //     unit: 130,
    //     user: 'Dima',
    // }
  ], []);
  return (0, _react.useMemo)(() => /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "w-100 h-100 flex-column ".concat(_HistoryModule.default.box)
  }, /*#__PURE__*/_react.default.createElement(_material.Box, null, /*#__PURE__*/_react.default.createElement("h6", {
    className: "color-main-color-primary medium"
  }, "Flush history")), /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "h-100"
  }, rows !== null && rows !== void 0 && rows.length ? /*#__PURE__*/_react.default.createElement(_DataGridProTable.default, {
    columns: columns,
    rows: rows,
    headerHeight: 26,
    margin: "18px 0 0 0",
    autoHeight: false
  }) : /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "flex-center h-100"
  }, /*#__PURE__*/_react.default.createElement("h6", {
    className: _HistoryModule.default.empty
  }, "No past flushes.")))), [columns, rows]);
};
var _default = exports.default = History;